import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=7f7d8444&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=7f7d8444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d8444",
  null
  
)

export default component.exports